import { baseApi, defaultQueryFreshness } from "./baseApi";
import type { PagedResult, TradeItem } from "../../api/trades";

export const tradesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTrades: builder.query<PagedResult<TradeItem>, Record<string, string | number | boolean | undefined> | void>({
      query: (params) => ({ url: "/trades", method: "GET", params, usePublic: true }),
      providesTags: (result) => [
        { type: "Trades", id: "LIST" },
        ...((result?.items || []).map((item) => ({ type: "Trades" as const, id: String(item.id) }))),
      ],
      ...defaultQueryFreshness,
    }),
    getTradeById: builder.query<TradeItem, string>({
      query: (id) => ({ url: `/trades/${id}`, method: "GET", usePublic: true }),
      providesTags: (_res, _err, id) => [{ type: "Trades", id: String(id) }],
      ...defaultQueryFreshness,
    }),
    createTrade: builder.mutation<unknown, FormData>({
      query: (formData) => ({ url: "/trades", method: "POST", data: formData, timeout: 30000 }),
      invalidatesTags: [{ type: "Trades", id: "LIST" }],
    }),
    deleteTrade: builder.mutation<unknown, string>({
      query: (id) => ({ url: `/trades/${id}`, method: "DELETE" }),
      invalidatesTags: (_res, _err, id) => [{ type: "Trades", id: String(id) }, { type: "Trades", id: "LIST" }],
    }),
    updateTradeLocation: builder.mutation<unknown, { id: string; location: Record<string, unknown> }>({
      query: ({ id, location }) => ({ url: `/trades/${id}/location`, method: "PATCH", data: location }),
      invalidatesTags: (_res, _err, { id }) => [{ type: "Trades", id: String(id) }, { type: "Trades", id: "LIST" }],
    }),
  }),
});

export const {
  useGetTradesQuery,
  useGetTradeByIdQuery,
  useCreateTradeMutation,
  useDeleteTradeMutation,
  useUpdateTradeLocationMutation,
} = tradesApi;
